import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

export type SharedActionVariant =
  | "primary"
  | "secondary"
  | "add"
  | "destructive";

@Component({
  selector: "app-shared-action-button",
  templateUrl: "./shared-action-button.component.html",
  styleUrls: ["./shared-action-button.component.scss"],
  standalone: false,
})
export class SharedActionButtonComponent {
  @Input() variant: SharedActionVariant = "primary";
  @Input() disabled = false;
  @Input() loading = false;
  @Input() fullWidth = false;
  @Input() type: "button" | "submit" = "button";
  @Input() ariaLabel?: string;
  @Output() pressed = new EventEmitter<MouseEvent>();

  @HostBinding("class.shared-action-button--full-width")
  get fullWidthClass(): boolean {
    return this.fullWidth;
  }
}
